import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from '../firebase';
import { saveFcmToken } from '../services/userService';

const NotificationManager = () => {
  
  const registerToken = async (token) => {
    try {
        const storedToken = localStorage.getItem('fcmToken');
        if (storedToken === token) return; // Skip if already sent

        // Assuming axios is configured with base URL and interceptors in 'api/axios' or similar. 
        // If not, we use basic fetch or direct axios.
        // We need the auth token here.
        // const authToken = localStorage.getItem('token'); 
        // if (!authToken) return;

        // Use relative URL - axios default baseURL (set in App.jsx) handles the domain
        await saveFcmToken(token);
        
        localStorage.setItem('fcmToken', token);
        console.log('FCM Token registered with server.');

    } catch (error) {
        console.error('Error registering FCM token:', error);
    }
  };

  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          
          // Register Service Worker with config params
          const swUrl = `/firebase-messaging-sw.js?apiKey=${import.meta.env.VITE_FIREBASE_API_KEY}&authDomain=${import.meta.env.VITE_FIREBASE_AUTH_DOMAIN}&projectId=${import.meta.env.VITE_FIREBASE_PROJECT_ID}&storageBucket=${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET}&messagingSenderId=${import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID}&appId=${import.meta.env.VITE_FIREBASE_APP_ID}`;
          
          let registration;
          try {
             registration = await navigator.serviceWorker.register(swUrl);
             console.log('Service Worker registered with scope:', registration.scope);
          } catch (err) {
             console.error('Service Worker registration failed:', err);
             return;
          }

          const token = await getToken(messaging, { 
            vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration
          });
          
          if (token) {
            console.log('FCM Token:', token);
            await registerToken(token);
          } else {
            console.log('No registration token available. Request permission to generate one.');
          }
        } else {
          console.log('Unable to get permission to notify.');
        }
      } catch (error) {
        console.error('An error occurred while retrieving token. ', error);
      }
    };

    requestPermission();

    // Handle foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
        // You can customize how to show this notification in the app (e.g., toast)
        new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: '/logo.png',
        });
    });

    return () => {
        unsubscribe();
    };
  }, []);

  return null;
};

export default NotificationManager;
